import { useEffect, useState } from "react";
import { useNavigate } from "react-router";

import axios from "axios";

import { DashboardLayout } from "../../Layout/DashboardLayout";
import BackButton from "../../Components/BackButton";
import CustomInput from "../../Components/CustomInput";
import CustomButton from "../../Components/CustomButton";
import { questionModal, successModal } from "../../Components/CustomModal";
import CustomLoader from "../../Components/CustomLoader";
import { checkAudioFormat } from "../../Util/helpers";

import { placeholderImage } from "../../Assets/images";

import "./style.css";
import BASEURL from "../../Config/global";
import { postRequest } from "../../Util/requests";
import { translateEnglishToSpanish, translateFromSpanish } from "../../Util/translator";
import MultiSelectDropdown from "../../Components/MultiSelectDropdown";

const AddSound = () => {
  const navigate = useNavigate();

  const [soundOptions, setSoundOptions] = useState([]);
  const [subCategories, setSubCategories] = useState([])

  const [formData, setFormData] = useState({});
  const [selectedImage, setSelectedImage] = useState(null);
  const [selectedThumbnail, setSelectedThumbnail] = useState(null);
  const [featuredState, setFeaturedState] = useState(false);

  const [soundAndroid, setSoundAndroid] = useState(null);
  const [soundErrorAndroid, setSoundErrorAndroid] = useState(false);

  const [soundIphone1, setSoundIphone1] = useState(null);
  const [soundErrorIphone1, setSoundErrorIphone1] = useState(false);

  const [soundIphone2, setSoundIphone2] = useState(null);
  const [soundErrorIphone2, setSoundErrorIphone2] = useState(false);

  const [mobileSound, setMobileSound] = useState(null);
  const [mobileSoundError, setMobileSoundError] = useState(false);

  const [soundImage, setSoundImage] = useState(null);
  const [soundThumbnail, setSoundThumbnail] = useState(null);
  const [mobileAudioDuration, setMobileAudioDuration] = useState(null);
  const [childContent, setChildContent] = useState(false);
  const [selectedLanguage, setSelectedLanguage] = useState('english');


  const [loginError, setLoginError] = useState({ error: false, text: "" });
  const [loader, setLoader] = useState(false);
  const [duplicateLoader, setDuplicateLoader] = useState(false);

  useEffect(() => {
    async function fetchSound() {
      try {
        const languageParam = selectedLanguage === "spanish" ? "?language=spanish" : "";
        const response = await axios.get(
          `${BASEURL}/api/sounds/soundscategories${languageParam}`
        );
        setSoundOptions(response.data.data);
      } catch (error) {
        console.error(error);
      }
    }
    fetchSound();
  }, [selectedLanguage]);

  useEffect(() => {
    if (!formData?.category_ids || formData?.category_ids?.length == 0) {
      setSubCategories([]);
    }
    if (formData?.category_ids?.length > 0 && formData?.category_ids?.length < 2) {
      getSubCategoriesOfCurrentSoundCategory(formData?.category_ids?.[0]?.value);
    }
  }, [formData, selectedLanguage]);

  const getSubCategoriesOfCurrentSoundCategory = async (soundcategory) => {
    const requestOptions = {
      method: "GET",
      redirect: "follow",
    };
    const languageParam = selectedLanguage === "spanish" ? "?language=spanish" : "";
    fetch(
      `${BASEURL}/api/sounds/soundscategories/${soundcategory}${languageParam}`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        if (result.status === 200) {
          const { category_data } = result?.data[0];
          setSubCategories(category_data);
        }
      })
      .catch((error) => console.error(error));
  };

  // useEffect(() => {
  //   const firstCategory = soundOptions[0]?.id.toString();
  //   setFormData({ category: firstCategory });
  // }, [soundOptions]);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData({ ...formData, [name]: value });
  };
  const handleChangeCategory = (event) => {
    const { name, value } = event.target;
    setFormData({ ...formData, [name]: value, soundSubCategory: "undefined" });
  }

  const handleSoundChangeAndroid = (event) => {
    const audioResult = checkAudioFormat(event);
    setSoundAndroid(audioResult.selectedFile);
    setSoundErrorAndroid(audioResult.error);
  };

  const handleSoundChangeIphone1 = (event) => {
    const audioResult = checkAudioFormat(event);
    setSoundIphone1(audioResult.selectedFile);
    setSoundErrorIphone1(audioResult.error);
  };

  const handleSoundChangeIphone2 = (event) => {
    const audioResult = checkAudioFormat(event);
    setSoundIphone2(audioResult.selectedFile);
    setSoundErrorIphone2(audioResult.error);
  };

  const handleMobileSoundChange = (event) => {
    const audioResult = checkAudioFormat(event);
    handleFileChange(event)
    setMobileSound(audioResult.selectedFile);
    setMobileSoundError(audioResult.error);
  };
  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();

      // Load the file into an audio context to get the duration
      reader.onload = (e) => {
        const audioContext = new (window.AudioContext || window.webkitAudioContext)();
        audioContext.decodeAudioData(e.target.result, (buffer) => {
          const duration = buffer.duration;
          setMobileAudioDuration(duration)
          console.log(`The duration of the file is ${duration} seconds.`);
        });
      };

      reader.readAsArrayBuffer(file);
    }
  };

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    setSelectedImage(file);

    if (file === null || file === "undefined") {
      setSoundImage(null);
    } else {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        setSoundImage(reader.result);
      };
    }
  };

  const handleThumbnailChange = (event) => {
    const file = event.target.files[0];
    setSelectedThumbnail(file);

    if (file === null || file === "undefined") {
      setSoundThumbnail(null);
    } else {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        setSoundThumbnail(reader.result);
      };
    }
  };


  const postSound = async (language = null, translatedTitle = null) => {
    const formDataToSend = new FormData();
    // console.log(soundAndroid)
    if (soundAndroid) {
      formDataToSend.append("audio", soundAndroid);
    }
    if (soundIphone1 && soundIphone2) {
      formDataToSend.append("ios_sound", soundIphone1);
      formDataToSend.append("ios_patch", soundIphone2);
    }
    if (mobileSound) {
      formDataToSend.append("audio_mobile", mobileSound);
    }
    if (mobileAudioDuration) {
      formDataToSend.append("duration", mobileAudioDuration);
    }
    formDataToSend.append("image", selectedImage);
    formDataToSend.append("thumbnail", selectedThumbnail);
    // Use translated title if provided, otherwise use original title
    formDataToSend.append("title", translatedTitle || formData.title);
    formDataToSend.append("premium", formData.premium);
    // if (formData.soundSubCategory && formData.soundSubCategory !== 'undefined') {
    //   formDataToSend.append("soundcategory", formData.soundSubCategory);
    // } else {
    //   formDataToSend.append("soundcategory", formData.category);
    // }
    formDataToSend.append("featured", featuredState);
    formDataToSend.append("naration", false);
    formDataToSend.append("child_content", childContent);
    formDataToSend.append("category_ids", formData?.category_ids?.map?.((item) => item.value));
    formDataToSend.append("subcategory_ids", formData?.subcategory_ids?.map?.((item) => item.value));

    // Add language to FormData if provided
    if (language) {
      formDataToSend.append("language", language);
    }

    try {
      const response = await postRequest(`/api/sounds/`, formDataToSend, null)
      if (response.data.error === false) {
        return { success: true, response: response.data };
      } else {
        return { success: false, error: response.data.message };
      }
    } catch (error) {
      return { success: false, error: "An error occurred. Please try again later." };
    }
  };

  const handleDuplicateAndAdd = async () => {
    if (!soundAndroid && !(soundIphone1 && soundIphone2)) {
      setLoginError({ error: true, text: "Please select audio files first" });
      return;
    }
    setDuplicateLoader(true);
    setLoginError({ error: false, text: "" });

    try {
      // Step 1: Post the first sound with current language
      const currentLanguage = selectedLanguage;
      const firstResult = await postSound(currentLanguage, null);

      if (!firstResult.success) {
        setLoginError({ error: true, text: `First sound failed: ${firstResult.error}` });
        setDuplicateLoader(false);
        return;
      }

      // Step 2: Translate title to the other language
      let translatedTitle = null;
      const targetLanguage = currentLanguage === 'english' ? 'spanish' : 'english';

      if (formData.title) {
        let translationResult;
        if (currentLanguage === 'english') {
          // Translate English to Spanish
          translationResult = await translateEnglishToSpanish(formData.title);
        } else {
          // Translate Spanish to English
          translationResult = await translateFromSpanish(formData.title);
        }

        if (translationResult.success) {
          translatedTitle = translationResult.translatedText;
        } else {
          setLoginError({ error: true, text: `Translation failed: ${translationResult.error}` });
          setDuplicateLoader(false);
          return;
        }
      }

      // Step 3: Post the second sound with translated title and other language
      const secondResult = await postSound(targetLanguage, translatedTitle);

      if (secondResult.success) {
        successModal.fire({
          text: `Sound added successfully in both ${currentLanguage} and ${targetLanguage}!`,
          confirmButtonText: "Continue",
        });
        setLoginError({ error: false, text: "" });
        setDuplicateLoader(false);
        navigate("/sound-management");
      } else {
        setLoginError({ error: true, text: `Second sound failed: ${secondResult.error}` });
        setDuplicateLoader(false);
      }
    } catch (error) {
      setLoginError({
        error: true,
        text: "An error occurred during duplicate operation. Please try again later.",
      });
      setDuplicateLoader(false);
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!formData?.category_ids || formData?.category_ids?.length === 0) {
      setLoginError({ error: true, text: "Please select at least one category" });
      return;
    }
    if (soundAndroid || (soundIphone1 && soundIphone2)) {
      const currentLanguage = selectedLanguage;
      const languageText = currentLanguage === 'english' ? 'English' : 'Spanish';

      questionModal
        .fire({
          title: `Do you want to add this Sound in ${languageText}?`,
          confirmButtonText: "Add",
        })
        .then((result) => {
          if (result.isConfirmed) {
            setLoader(true);
            postSound(currentLanguage, null).then((result) => {
              setLoader(false);
              if (result.success) {
                successModal.fire({
                  text: "Sound Added Successfully",
                  confirmButtonText: "Continue",
                });
                setLoginError({ error: false, text: "" });
                navigate("/sound-management");
              } else {
                setLoginError({ error: true, text: result.error });
              }
            });
          }
        });
    }
  };

  return (
    <>
      <DashboardLayout>
        <div className="container-fluid">
          <div className="row mb-3">
            <div className="col-12 mb-2">
              <h2 className="mainTitle">
                <BackButton />
                Add Sound
              </h2>
            </div>
          </div>
          <div className="row mb-3">
            <div className="col-12">
              <form onSubmit={handleSubmit}>
                <div className="row mb-3">
                  <div className="col-lg-6 mb-4">
                    <CustomInput
                      label="Title"
                      labelClass="mainLabel"
                      required
                      type="text"
                      name="title"
                      value={formData.title || ""}
                      placeholder="Enter Title"
                      inputClass="mainInput"
                      onChange={handleChange}
                    />
                  </div>
                  <div className="col-lg-6 mb-4">
                    <p className="mainLabel">Type</p>
                    <label className="secondaryText me-3">
                      <input
                        type="radio"
                        name="premium"
                        required
                        value={"false"}
                        className="me-1"
                        onChange={handleChange}
                      />
                      Free
                    </label>
                    <label className="secondaryText">
                      <input
                        type="radio"
                        name="premium"
                        required
                        value={"true"}
                        className="me-1"
                        onChange={handleChange}
                      />
                      Premium
                    </label>
                  </div>
                  <div className="col-lg-6 mb-4">
                    <p className="mainLabel">Sound <span style={{ fontSize: "10px" }}>(Ogg file)</span>*</p>
                    <label>
                      <div className="audioInput">
                        <span>Select Audio File</span>
                      </div>
                      {soundAndroid && (
                        <p className="audioInputName oneLine">{soundAndroid.name}</p>
                      )}
                      {soundErrorAndroid && (
                        <p className="audioInputName">
                          Please select correct file format
                        </p>
                      )}
                      <input
                        type="file"
                        name="sound"
                        accept="audio/*"
                        className="d-none"
                        onChange={handleSoundChangeAndroid}
                      />
                    </label>
                  </div>
                  <div className="col-lg-6 mb-4">
                    <p className="mainLabel">Iphone Sound <span style={{ fontSize: "10px" }}>(Mp3 file)</span>*</p>
                    <label>
                      <div className="audioInput">
                        <span>Select Audio File</span>
                      </div>
                      {soundIphone1 && (
                        <p className="audioInputName oneLine">{soundIphone1.name}</p>
                      )}
                      {soundErrorIphone1 && (
                        <p className="audioInputName">
                          Please select correct file format
                        </p>
                      )}
                      <input
                        type="file"
                        name="sound"
                        accept="audio/*"
                        className="d-none"
                        onChange={handleSoundChangeIphone1}
                      />
                    </label>
                  </div>
                  <div className="col-lg-6 mb-4">
                    <p className="mainLabel">Iphone Sound Ghost<span style={{ fontSize: "10px" }}>(Mp3 Patch file)</span>*</p>
                    <label>
                      <div className="audioInput">
                        <span>Select Audio File</span>
                      </div>
                      {soundIphone2 && (
                        <p className="audioInputName oneLine">{soundIphone2.name}</p>
                      )}
                      {soundErrorIphone2 && (
                        <p className="audioInputName">
                          Please select correct file format
                        </p>
                      )}
                      <input
                        type="file"
                        name="sound"
                        accept="audio/*"
                        className="d-none"
                        onChange={handleSoundChangeIphone2}
                      />
                    </label>
                  </div>
                  <div className="col-lg-6 mb-4">
                    <p className="mainLabel">Mobile Native<span style={{ fontSize: "10px" }}>(Mp3 file)</span>*</p>
                    <label>
                      <div className="audioInput">
                        <span>Select Audio File</span>
                      </div>
                      {mobileSound && (
                        <p className="audioInputName oneLine">{mobileSound.name}</p>
                      )}
                      {mobileSoundError && (
                        <p className="audioInputName">
                          Please select correct file format
                        </p>
                      )}
                      <input
                        type="file"
                        name="sound"
                        accept="audio/*"
                        className="d-none"
                        onChange={handleMobileSoundChange}
                      />
                    </label>
                  </div>
                  <div className="col-lg-6 mb-4">
                    <p className="mainLabel">Select Category*</p>
                    <MultiSelectDropdown
                      value={formData.category_ids || ""}
                      name="category_ids"
                      options={soundOptions}
                      onChange={(__data) => {
                        setFormData({ ...formData, category_ids: __data, subcategory_ids: "undefined" });
                      }}
                    />
                  </div>
                  <div className="col-lg-6 mb-4">
                    {
                      (!formData?.category_ids || formData?.category_ids?.length < 2) && (
                        <>
                          <p className="mainLabel">Select SubCategory*</p>
                          <MultiSelectDropdown
                            value={formData.subcategory_ids || ""}
                            name="subcategory_ids"
                            options={subCategories}
                            onChange={(__data) => {
                              setFormData({ ...formData, subcategory_ids: __data });
                            }}
                          />
                        </>
                      )
                    }
                  </div>
                  <div className="col-lg-6 mb-4">
                    <p className="mainLabel">Thumbnail*</p>
                    <label>
                      <div className="thumbnailInput">
                        {soundThumbnail ? (
                          <img src={soundThumbnail} alt="Thumbnail" />
                        ) : (
                          <img src={placeholderImage} alt="Thumbnail" />
                        )}
                      </div>
                      <input
                        type="file"
                        id="image"
                        accept="image/*"
                        className="d-none"
                        required
                        onChange={handleThumbnailChange}
                      />
                    </label>
                  </div>
                  <div className="col-lg-6 mb-4">
                    <p className="mainLabel">Image*</p>
                    <label>
                      <div className="imageInput">
                        {soundImage ? (
                          <img src={soundImage} alt="Main" />
                        ) : (
                          <img src={placeholderImage} alt="Main" />
                        )}
                      </div>
                      <input
                        type="file"
                        id="image"
                        accept="image/*"
                        className="d-none"
                        required
                        onChange={handleImageChange}
                      />
                    </label>
                  </div>
                  <div className="col-lg-3 align-self-end mb-4">
                    <input
                      type="checkbox"
                      name="featured"
                      id="featured"
                      onChange={() => {
                        setFeaturedState(!featuredState);
                      }}
                    />
                    <label htmlFor="featured" className="mainLabel ms-1">
                      Featured
                    </label>
                  </div>
                  <div className="col-lg-3 align-self-end mb-4">
                    <input
                      type="checkbox"
                      name="underage_restriction"
                      id="underage_restriction"
                      onChange={() => {
                        setChildContent(!childContent);
                      }}
                      value={childContent}
                      checked={childContent ? true : false}
                    />
                    <label htmlFor="underage_restriction" className="mainLabel ms-1">
                      underage restriction
                    </label>
                  </div>
                  <div className="col-lg-4 mb-4">
                    <p className="mainLabel">Select Language*</p>
                    <select
                      name="language"
                      id="language"
                      className="mainInput "
                      value={selectedLanguage}
                      onChange={(e) => setSelectedLanguage(e.target.value)}
                    // style={{ width: '33%' }}
                    >
                      <option value="english">English</option>
                      <option value="spanish">Spanish</option>
                    </select>
                  </div>
                </div>
                {loginError.error == true && (
                  <div className="row mb-3">
                    <div className="col-12">
                      <p className="secondaryText">{loginError.text}</p>
                    </div>
                  </div>
                )}
                <div className="row">
                  <div className="col-12">
                    <div style={{ display: 'flex', gap: '1rem', alignItems: 'center' }}>
                      <CustomButton
                        type="submit"
                        variant="primaryButton"
                        text="Add"
                        disabled={loader || duplicateLoader}
                      />
                      {selectedLanguage === 'english' && (
                        <CustomButton
                          type="button"
                          variant="secondaryButton"
                          text="Duplicate in Spanish"
                          onClick={(e) => {
                            e.preventDefault();
                            questionModal
                              .fire({
                                title: "Do you want to add this Sound in both English and Spanish?",
                                text: "This will add the sound twice - once in English and once in Spanish (with translated title).",
                                confirmButtonText: "Yes, Add Both",
                              })
                              .then((result) => {
                                if (result.isConfirmed) {
                                  handleDuplicateAndAdd();
                                }
                              });
                          }}
                          disabled={loader || duplicateLoader}
                        />
                      )}
                      {selectedLanguage === 'spanish' && (
                        <CustomButton
                          type="button"
                          variant="secondaryButton"
                          text="Duplicate in English"
                          onClick={(e) => {
                            e.preventDefault();
                            questionModal
                              .fire({
                                title: "Do you want to add this Sound in both Spanish and English?",
                                text: "This will add the sound twice - once in Spanish and once in English (with translated title).",
                                confirmButtonText: "Yes, Add Both",
                              })
                              .then((result) => {
                                if (result.isConfirmed) {
                                  handleDuplicateAndAdd();
                                }
                              });
                          }}
                          disabled={loader || duplicateLoader}
                        />
                      )}
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </DashboardLayout>
      {(loader || duplicateLoader) && <CustomLoader />}
    </>
  );
};
export default AddSound;
